import * as React from 'react';
import * as mrCap from '../../mrCapTypes';
import { className } from '../../util';

interface ShopProps {
  shop: mrCap.Shop;
  selectedShop: mrCap.Shop | null;
  click: (shop: mrCap.Shop) => void;
  updateTimes: (id: number) => void;
}

export function Shop({ shop, selectedShop, click, updateTimes }: ShopProps) {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    click(shop);
    updateTimes(shop.id);
  };

  return (
    <div className={className('shop', { selected: selectedShop && selectedShop.id === shop.id })} >
      <a href={`#${shop.id}`} onClick={handleClick}>
        {shop.name}
      </a>
    </div>
  );
}